import { BigNumber } from '@ethersproject/bignumber';
export const sanitizeTx = tx => ({ ...tx,
  nonce: tx.nonce !== undefined ? BigNumber.from(tx.nonce).toNumber() : undefined
});
//# sourceMappingURL=sanitize.js.map